import React, { createContext, useEffect, useState } from 'react'
import { useAppCtx } from './app-ctx';

import ListResorts from './list-ListResorts';


const ResortsPage = () => {
    const {searchCriterias} = useAppCtx();
    return (
        <ListResorts searchCriterias={searchCriterias} />
    )
}

export default ResortsPage;
